<script setup>
import {onMounted, ref} from 'vue';

defineProps({
  modelValue: null,
});

defineEmits(['update:modelValue']);

const input = ref(null);

onMounted(() => {
  if (input.value.hasAttribute('autofocus')) {
    input.value.focus();
  }
});

defineExpose({focus: () => input.value.focus()});
</script>

<template>
  <textarea ref="input"
            class="shadow-sm border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block p-2.5 disabled:bg-white disabled:border-gray-200 disabled:text-gray-500"
            :value="modelValue"
            @input="$emit('update:modelValue', $event.target.value)"
  ></textarea>
</template>
